<template>
  <div>
    <img :style="{ content: content }" class="imagePreloader_components" :id="id">
  </div>
</template>

<script>
export default {
  props: [
    'src',
    'srcs',
    'images',
    'image',
    'img',
    'imgs',
    'id'
  ],
  data() {
    return  {
      loadedCount: 0,
      processedCount: 0,
      loadedImgs: [],
      errorList: [],
      errorEmited: false,
    }
  },
  computed: {
    isError() {
      return this.loadedImgs.length > 0;
    },
    data() {
      return (this.src ? new Array(this.src) : [])
          .concat(this.srcs)
          .concat(this.images)
          .concat(this.image)
          .concat(this.img)
          .concat(this.imgs)
          .filter(e => { return e })
    },
    content() {
      return this.loadedImgs.length ? (this.loadedImgs.length > 1 ? 'url(' + this.loadedImgs.join(') url(') + ')' : 'url(' + this.loadedImgs[0] + ')') : ''
    }
  },
  watch: {
    data: function() {
      this.errorList = [];
      this.errorEmited = false;
      this.loadedCount = 0;
      this.processedCount = 0;
      this.loadedImgs = [];
      this.preloadImages();
    },
  },
  methods: {
    loaded(src, index) {
      this.loadedCount++
      this.loadedImgs.push(src)
      this.$emit('loaded', {
        id: this.id,
        src,
        index,
        count: this.loadedCount,
        length: this.data.length,
        progress: this.loadedCount / this.data.length * 100
      })
      if(this.loadedCount === this.data.length) this.$emit('loaded-all', this.id || true)
    },
    preloadImages: function() {
      const self = this;
      for(let i = this.data.length; i > 0; i--) {
        const img = new Image()
        const index = this.data.length - i
        this.processedCount++;
        img.src = this.data[index]
        img.onload = () => {
          self.loaded(img.src, index)
        }
        img.onerror = () => {
          self.errorList.push(img.src);
          if (!self.errorEmited) {
            this.$emit('onerror', {
              errorImgs: self.errorList
            });
            self.errorEmited = true;
          }
        }
      }
    }
  },
  mounted() {
    this.preloadImages();
  }
}
</script>

<style>
.imagePreloader_components {
  z-index: -1;
  width: 0;
  height: 0;
  position: fixed;
}
</style>
